module.exports = __webpack_public_path__ + "static/media/check-icon.5470e5df.svg";